// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fields-container {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    align-items: center;
  }
  .field-buttons {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .dialog-actions {
    margin-top: 56px;
    text-align: center;
  }
  .small-select {
    width: 180px; /* Adjust the width as needed */
  }
  .small-select-btn {
    width: 70px; /* Adjust the width as needed */
  }
  .selected-fields {
    position: relative;
    right: 0; /* Adjust the right position as needed */
    top: 32px; /* Adjust the top position as needed */
  }
  .move-right {
    margin-left: 40px;
    }`, "",{"version":3,"sources":["webpack://./src/app/shared/component/search-filter-modal/column-filter-dialog/column-filter-dialog.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,YAAY,EAAE,+BAA+B;EAC/C;EACA;IACE,WAAW,EAAE,+BAA+B;EAC9C;EACA;IACE,kBAAkB;IAClB,QAAQ,EAAE,wCAAwC;IAClD,SAAS,EAAE,sCAAsC;EACnD;EACA;IACE,iBAAiB;IACjB","sourcesContent":[".fields-container {\n    display: flex;\n    justify-content: space-between;\n    gap: 16px;\n    align-items: center;\n  }\n  .field-buttons {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n  .dialog-actions {\n    margin-top: 56px;\n    text-align: center;\n  }\n  .small-select {\n    width: 180px; /* Adjust the width as needed */\n  }\n  .small-select-btn {\n    width: 70px; /* Adjust the width as needed */\n  }\n  .selected-fields {\n    position: relative;\n    right: 0; /* Adjust the right position as needed */\n    top: 32px; /* Adjust the top position as needed */\n  }\n  .move-right {\n    margin-left: 40px;\n    }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
